import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface PathParameters {
  [parameterName: string]: string;
}

@Injectable({
  providedIn: 'root'
})
export class UrlBuilderService {
  private apiUrl: string;

  constructor() {
    this.apiUrl = environment.api;
  }

  public buildUrl(relativeUrl: string, pathParams?: PathParameters): string {
    let fullUrl = this.apiUrl;
    if (!this.apiUrl.endsWith('/') && !relativeUrl.startsWith('/')) {
      fullUrl = fullUrl.concat('/');
    }
    return fullUrl.concat(this.replacePathParams(relativeUrl, pathParams));
  }


  private replacePathParams(url: string, params?: PathParameters): string {
    const placeholders = url.match(/({[a-zA-Z]*})/g);
    if (placeholders) {
      placeholders.forEach((placeholder: string) => {
        const key = placeholder.substr(1, placeholder.length - 2);
        const value = params ? params[key] : null;
        if (!value) {
          throw new Error(`parameter ${key} was not provided`);
        }
        url = url.replace(placeholder, encodeURIComponent(value));
      });
    }
    return url;
  }
}
